<template>
  <div>
    <van-search placeholder="请输入搜索内容" v-model="searchValue" show-action>
      <template #action>
        <div class="search-btn" @click="onSearch">查询</div>
      </template>
    </van-search>
  </div>
</template>

<script>
export default {
  name: "SearchHeader",
  data() {
    return {
      searchValue: ''
    }
  },
  methods: {
    onSearch() {
      this.$emit('change', this.searchValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  font-size: 25px;
  color: #0090C5;
  font-weight: bold;
}
::v-deep {
  .van-field__control::placeholder{
    color: #666666;
  }
  .van-search--show-action {
    padding-left: 0;
  }
  .van-search__content {
    border-radius: 20px;
  }
  .van-icon-search {
    color: #0091C5;
  }
  .van-search__action {
    color: #999999;
    font-size: 14px;
  }
}
</style>
